<template>
  <section>
    <b-collapse
      class="card"
      animation="slide"
      aria-id="contentIdForA11y3"
      v-model="isOpenCollapse"
    >
      <template #trigger="props">
        <div
          class="card-header"
          role="button"
          aria-controls="contentIdForA11y3"
          :aria-expanded="props.open"
        >
          <p class="card-header-title">
            {{ academicArea.alt_name }}
          </p>
          <a class="card-header-icon">
            <b-icon :icon="props.open ? 'sort-down' : 'sort-up'"> </b-icon>
          </a>
        </div>
      </template>

      <div class="card-content">
        <div class="columns">
          <div class="column has-text-right">
            <b-button
              :label="
                openedDetail.length === 0
                  ? 'Expandir Observaciones'
                  : 'Contraer Observaciones'
              "
              :icon-left="
                openedDetail.length === 0 ? 'plus-circle' : 'minus-circle'
              "
              type="is-blue-color"
              @click="
                openedDetail.length === 0
                  ? (openedDetail = performances)
                  : (openedDetail = [])
              "
            />
          </div>
        </div>
        <b-table
          striped
          :data="performances"
          paginated
          per-page="10"
          :pagination-simple="false"
          pagination-position="bottom"
          aria-next-label="Siguiente"
          aria-previous-label="Anterior"
          aria-page-label="Página"
          aria-current-label="Página actual"
          detail-icon="plus-circle"
          :opened-detailed="openedDetail"
          detailed
        >
          <b-table-column
            field="alt_name_area"
            label="Área Académica"
            v-slot="props"
          >
            {{ props.row.alt_name_area }}
          </b-table-column>
          <b-table-column
            field="alt_name_activity"
            label="Actividad Académica"
            v-slot="props"
          >
            {{ props.row.alt_name_activity }}
          </b-table-column>
          <b-table-column
            v-if="
              academicArea.name === 'DOCENCIA' ||
              academicArea.name === 'EDUCACION CONTINUA'
            "
            field="alt_name_activity"
            label="Asignatura"
            v-slot="props"
          >
            {{
              (function () {
                if (
                  props.row.subject_code == null ||
                  props.row.subject_code === ""
                )
                  return "";
                const filtered = subjects.filter(
                  (subject) =>
                    parseInt(props.row.subject_code) === subject.codigo
                );
                return filtered.length > 0 ? filtered[0].codigo_nombre : "";
              })()
            }}
          </b-table-column>
          <b-table-column
            field="is_weekly_hours"
            label="Tipo de Hora"
            v-slot="props"
          >
            {{ props.row.is_weekly_hours ? "Semanales" : "Semestrales" }}
          </b-table-column>
          <b-table-column
            field="hours_committed_semester_1"
            label="Horas 1er Semestre"
            v-slot="props"
          >
            {{ props.row.hours_committed_semester_1 }}
          </b-table-column>
          <b-table-column
            field="hours_committed_semester_2"
            label="Horas 2do Semestre"
            v-slot="props"
          >
            {{ props.row.hours_committed_semester_2 }}
          </b-table-column>
          <template #detail="props">
            <div class="content">
              <p>
                <b>Observaciones:</b>
                <span class="preserve-line-breaks">{{
                  props.row.observations
                }}</span>
              </p>
            </div>
          </template>
          <template slot="empty" slot-scope="props">
            <div class="columns is-centered">
              <div class="column is-6 is-centered has-text-centered">
                <b-message type="is-warning">
                  Aún no ha agregado Actividades en
                  {{ academicArea.alt_name }}, a medida que agregue se irán
                  mostrando en esta tabla.
                </b-message>
              </div>
            </div>
          </template>
        </b-table>
      </div>
    </b-collapse>
  </section>
</template>

<script>
export default {
  name: "AreaCommitmentsCollapse",

  props: {
    academicArea: {
      type: Object,
      required: true,
    },
    performances: {
      type: Array,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: false,
    },
    subjects: {
      type: Array,
    },
  },

  data() {
    return {
      openedDetail: [],
      isOpenCollapse: this.isOpen,
    };
  },

  watch: {
    isOpen(val) {
      this.isOpenCollapse = val;
    },
  },
};
</script>

<style scoped>
.preserve-line-breaks {
  white-space: pre-wrap;
}
</style>
